import React from 'react';
import AppFooterStyles from './AppFooter.module.scss'

const icons = [
    {src: './dscrVk.svg', name: 'dscrVk', link: 'https://vk.com/epatazhnost'},
    {src: './dscrTg.svg', name: 'dscrTg', link: 'https://t.me/epatazhnost'},
    {src: './dscrYt.svg', name: 'dscrYt', link: 'https://www.youtube.com/@epatazhnost'},
];

const IconCard = ({src, name, link}: { src: string; name: string; link: string }) => (
    <div className={AppFooterStyles.icon}>
        <a href={link} target="_blank" rel="noopener noreferrer">
            <img src={src} alt={name} className={AppFooterStyles.iconItem}/>
        </a>
    </div>
);

const AppFooter = () => {
    return (
        <div className={AppFooterStyles.footerWrapper}>
            <div className={AppFooterStyles.footerContent}>
                <div className={AppFooterStyles.descriptions}>
                    <div className={AppFooterStyles.left}>
                        <div className={AppFooterStyles.contacts}>
                            <p className={AppFooterStyles.contactsItem}>Контакты:</p>
                        </div>
                        <div className={AppFooterStyles.address}>
                            <p className={AppFooterStyles.addressItem}>Город Москва, 2025
                                7(964)702-83-10
                                store@epatazhnost.world
                            </p>
                        </div>
                    </div>

                    <div className={AppFooterStyles.social}>
                        <p className={AppFooterStyles.socialItem}>А еще ищи нас в соцсетях:</p>
                        <div className={AppFooterStyles.iconList}>
                            {icons.map((icon, index) => (
                                <IconCard key={index} {...icon}/>
                            ))}
                        </div>
                    </div>
                </div>

                <div className={AppFooterStyles.logo}>
                    <img src="/logoWhite.svg" alt="logoWhite" className={AppFooterStyles.logoItem}/>
                    <div className={AppFooterStyles.logoText}>
                        <div className={AppFooterStyles.logoTextItem}>
                            <a href="/public-offering" style={{ color: 'inherit', textDecoration: 'none' }}>
                                Публичная оферта
                            </a>

                        </div>
                        <div className={AppFooterStyles.logoTextItem}>
                            <a href="/privacy-policy" style={{ color: 'inherit', textDecoration: 'none' }}>
                                Политика конфиденциальности
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
};

export default AppFooter;
